<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="pt2" epub:type="part" role="doc-part">
<header>
<h1 class="PT" id="pt2"><span aria-label="12" id="pg_12" role="doc-pagebreak"><samp class="SANS_Baruta_Black_B_17">EXPLORING WATERCOLOR</samp></span></h1>
</header>
<p class="Intro"><samp class="SANS_Menco_Light_17">I have always found watercolor magical. It’s a versatile medium that allows you to work fast if you’re aiming for a fresh take, or paint more slowly, working layer by layer to achieve beautifully detailed images. Watercolor can be playful, unpredictable, surprising, and whimsical. It requires a little practice to understand and learn the qualities of the paint, but once you start to grasp its magic, I’m sure you’ll fall in love with it, too!</samp></p>
<figure class="IMG"><img alt="" height="249" src="images/pg12-1.jpg" width="246"/>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?4d25387c